import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import LogoutIcon from '@mui/icons-material/Logout';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import logo from './resources/Logo_Website_2020.JPG';

export default function Header({ onSignOutClicked }) {
  const navigate = useNavigate();

  function onHomeClicked() {
    navigate(`/`);
  }

  async function onSignOut() {
    await onSignOutClicked()
    navigate(`/`);
  }

  return (
    <>
      <div id="header">
        <a href="https://skrootlab.com">
          <img src={logo} alt="Skroot Logo" style={{ width: 134, height: 55 }}></img>
        </a>
        <div id="menuButtons">
          <Button sx={{ width: 120, height: 30, margin: 1 }} variant="contained" onClick={onHomeClicked} endIcon={<HomeRoundedIcon />}>Home</Button>
          <Button sx={{ width: 120, height: 30, margin: 1 }} variant="contained" onClick={onSignOut} endIcon={<LogoutIcon />}>Logout</Button>
        </div>
      </div>
    </>
  )
}